import { IRequirement } from "../../../types/searchRequest";
import { DEFAULT_CAT_STATES } from "../common/constants/assignment-filters";
import { CredentialsViewMode } from "../types/common";

export const AUTO_SAVE_DELAY = 2000; // 2 sec

export const CREDENTIALS_PER_PAGE = 10;
export const GRID_CREDENTIALS_PER_PAGE = 15;

export const CREDENTIALS_VIEW_TYPE: { label: string, value: CredentialsViewMode, icon: string }[] = [
  { 'label': 'List', value: 'list', icon: 'list' },
  { 'label': 'Grid', value: 'grid', icon: 'grid_view' },
];

export const ASSIGNMENT_TYPE = [
  'Full Search',
  'Internal',
  'Consulting',
  'Open / Close',
  'Pre - Search',
  'Reference Check',
  'Special Project'
];

export const RRA_INDUSTRY = [
  'Consumer',
  'Financial Services',
  'Healthcare',
  'Industrial & Natural Resources',
  'Social Impact & Education',
  'Technology',
  'Industry Agnostic',
] as const;

export const RRA_PRACTICE: Record<typeof RRA_INDUSTRY[number], string[]> = {
  'Consumer': ['Consumer Products & Services', 'Leisure & Hospitality', 'Media, Entertainment, Games, & Sport', 'Retail & Luxury', 'Practice Agnostic'],
  'Financial Services': ['Banking & Lending', 'Insurance', 'Investment Management', 'Practice Agnostic'],
  'Healthcare': ['Health Services', 'Healthcare Technology', 'Med Tech, Devices & Diagnostics', 'Pharmaceuticals & Biotechnology', 'Practice Agnostic'],
  'Industrial & Natural Resources': ['Automotive', 'Chemicals, Materials & Packaging', 'Global Energy & Natural Resources', 'Industrial Goods', 'Industrial Services & Infrastructure', 'Practice Agnostic'],
  'Social Impact & Education': ['Arts & Culture', 'Education', 'Global Development, Advocacy & Philanthropy', 'Public Sector', 'Trade & Professional Associations', 'Practice Agnostic'],
  'Technology': ['Business & Professional Services', 'Connectivity', 'Digital Platforms', 'Hardware & IOT', 'Software & Cloud', 'Practice Agnostic'],
  'Industry Agnostic': ['Practice Agnostic'],
};

export const RRA_CAPABILITY = [
  'BCAP',
  'Culture',
  'Customer Activation & Growth',
  'Diversity, Equity & Inclusion',
  'Development',
  'Financial Officers',
  'Human Resources Officers',
  'Legal, Regulatory, Compliance & Risk',
  'Assessment',
  'Operations & Supply Chain Officers',
  'Infrastructure',
  'Private Credit',
  'Private Equity',
  'Real Estate',
  'Venture Capital',
  'Sustainability',
  'Technology Officers',
  'Agnostic',
]

// Global Filter to be applied by default - https://findemjira.atlassian.net/browse/RRINT-773
export const GLOBAL_REQUIREMENT: IRequirement[] = [
  {
    // Exclude PNB Project Type AND Exclude Completed/Open Assignment Status
    bool_str: `(${DEFAULT_CAT_STATES['project_type'].kw_prefix}:!PNB)`,
    is_negative: false,
    req_type: "good to have",
    section_id: "internal",
    section_order: 0,
    section_type: "Must Have",
  },
  {
    // Supported assignment statuses included in default Cred Builder results
    bool_str: `(${DEFAULT_CAT_STATES['status'].kw_prefix}:Completed OR ${DEFAULT_CAT_STATES['status'].kw_prefix}:Open OR ${DEFAULT_CAT_STATES['status'].kw_prefix}:Reopened OR ${DEFAULT_CAT_STATES['status'].kw_prefix}:New OR ${DEFAULT_CAT_STATES['status'].kw_prefix}:Resolved OR ${DEFAULT_CAT_STATES['status'].kw_prefix}:Suspended OR ${DEFAULT_CAT_STATES['status'].kw_prefix}:Cancelled)`,
    is_negative: false,
    req_type: "good to have",
    section_id: "internal",
    section_order: 0,
    section_type: "Must Have",
  },
  {
    // Supported assignment types included in default Cred Builder results
    bool_str: `(${DEFAULT_CAT_STATES['assignment_type'].kw_prefix}:Full Search OR ${DEFAULT_CAT_STATES['assignment_type'].kw_prefix}:Pre-Search OR ${DEFAULT_CAT_STATES['assignment_type'].kw_prefix}:Open/Close OR ${DEFAULT_CAT_STATES['assignment_type'].kw_prefix}:Consulting OR ${DEFAULT_CAT_STATES['assignment_type'].kw_prefix}:Special Project)`,
    is_negative: false,
    req_type: "good to have",
    section_id: "internal",
    section_order: 0,
    section_type: "Must Have",
  },
];

export enum QueryParams {
  HomeTab = 'homeTab',
}
